/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-03 15:15:19
 **/

import { Button, Row, Icon, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import { colors } from "@/frameworks/core/styles";
import { usePhoneFavorite, useFriendHandlers, usePopover } from "@/frameworks/core/hooks";
import { i18nSpaceLocationName } from "@/frameworks/core/utils";

import * as S from "../emotion";
import { usePersistActions } from "@/frameworks/core/persistence";

type NormalCommandsProps = {
	userID: string;
	handleChatUser: () => void;
};

export default function NormalCommands(props: NormalCommandsProps) {
	const popover = usePopover();
	const { userID, handleChatUser } = props;
	const dispatch = usePersistActions();
	const userInfo = userID && dispatch.users.get_user(userID);
	const favorite = usePhoneFavorite();
	const {
		handlers: { handleFollowHome, handleFavorites, handleFollowUser }
	} = useFriendHandlers();

	return (
		<>
			<Row.ul horizonAlign="center" gap={19}>
				<li id="home">
					<Button.Icon name="Home24" size="Xlarge" variant="text" onClick={() => handleFollowHome(userID)} />
				</li>
				<li id="chat">
					<Button.Icon name="Chat0124" size="Xlarge" variant="text" onClick={handleChatUser} />
				</li>
				<li id="favorite">
					<Button.Icon
						name={favorite.has(userID) ? "StarFill24" : "Star24"}
						size="Xlarge"
						variant="text"
						onClick={async () =>
							await handleFavorites({
								active: favorite.has(userID),
								userID: userID
							})
						}
					/>
				</li>
			</Row.ul>
			<Row.div verticalAlign="center" horizonAlign="center">
				<S.ButtonLocation
					filled="transparent"
					onClick={() => {
						handleFollowUser(userID);
						popover.hideAll();
					}}
				>
					<S.IconWrapLocation>
						<Icon name="Place16" size="16" fill={colors.neutral_60_100} />
					</S.IconWrapLocation>
					<Typography
						typoSize="Body4"
						typoColor="neutral_70_100"
						ellipsis
						style={{
							whiteSpace: "nowrap",
							overflow: "hidden"
						}}
					>
						{userInfo &&
							`${_T("현재 위치 : {{location}}", {
								location: i18nSpaceLocationName({
									currentSpace: userInfo?.currentSpace,
									currentConference: userInfo?.currentConference,
									activeStatus: userInfo?.activeStatus
								})
							})}`}
					</Typography>
				</S.ButtonLocation>
			</Row.div>
		</>
	);
}
